var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#000000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 21,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#fff"
  }, "AP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplepay);
export default __webpack_public_path__ + "static/media/applepay.ce6afc38a33b490a588feb21d6e52343.svg";
export { ForwardRef as ReactComponent };